PJQ.views.settings.UserSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'user-management'),
        subTemplates: {
            userSeats: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'user-management-user-seats-header'),
            userLimits: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'user-management-user-limits-header')
        }
    },
    events: {
        'change .cb-enable-permissions': 'enablePermissions',
        'click .btn-add-user': 'addClicked',
        'click .btn-edit-user-perms': 'editPermissionsClicked',
        'click .btn-edit-user': 'editClicked',
        'click .btn-delete-user': 'deleteClicked',
        'click .btn-edit-notification-settings': 'notificationSettingsClicked',
        'click .btn-change-seats': 'manageUserSeats',
        'click .btn-change-limits': 'manageUserLimits'
    },
    beforeRender: function () {
        this.options.enablePermissions = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS);
    },
    renderData: function () {
        return {
            enablePermissions: this.options.enablePermissions
        };
    },
    afterRender: function () {

        let columns = [
            {
                'title': "hidden_search",
                "data": "",
                'width': '0px',
                'visible': false,
                "render": _.bind(function (data, type, row) {
                    return row.get('phone') + ' ' + row.get('address1') + ' ' + row.get('address2') + ' ' + row.get('city') + ' ' + row.get('state') + ' ' + row.get('zip');
                })
            },
            {
                'title': "Active",
                "data": "attributes.isActive",
                'width': '40px',
                "render": _.bind(function (data, type, row) {
                    let content = '';
                    if (data === true) {
                        content = '<i class="fas fa-circle" style="color: #5cb85c"><div hidden>true</div></i>'
                    } else {
                        content = '<i class="fas fa-circle" style="color: #d9534f"><div hidden>false</div></i>'
                    }
                    return content
                })
            },
            {
                "title": "User Type",
                "data": "userType",
                "render": _.bind(function (data, type, row) {
                    if (type === 'sort' && row.userType !== undefined) {
                        return row.userType.get('sortOrder');
                    }
                    return '<span style="color:' + (row.userType !== undefined ? row.userType.get('color') : '#000000') + ';">' + (row.userType !== undefined ? row.userType.get('name') : "") + '</span>';
                }, this)
            },
            {
                "title": "Username",
                "data": "attributes.username",
            },
            {
                "title": "Name",
                "data": "attributes.contactName",
            },
            {
                "title": "Email",
                "data": "attributes.email",
            },
            {
                'title': "ITB User",
                "data": "attributes.itbUser",
                'width': '40px',
                "render": _.bind(function (data, type, row) {
                    let content = '';
                    if (data === true) {
                        content = '<i class="fas fa-check text-dark"></i>'
                    }
                    return content
                })
            },
            {
                'title': "PM User",
                "data": "attributes.pmUser",
                'width': '40px',
                "render": _.bind(function (data, type, row) {
                    let content = '';
                    if (data === true) {
                        content = '<i class="fas fa-check text-dark"></i>'
                    }
                    return content
                })
            }
        ];

        // for Document Clerk add the CreatedOn column to assist with billing
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {
            columns.push({
                "columnData": "createdDate",
                "data": {
                    "_": function (row) {
                        return new Date(row.attributes.createdDate);
                    },
                    "filter": "attributes.createdDate",
                    "display": function (row) {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.createdDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                "title": "Created"
            });
        }

        columns.push({
            "data": "",
            "title": "",
            "orderable": false,
            "searchable": false,
            "width": this.options.enablePermissions ? '160px' : '120px',
            "render": _.bind(function (data, type, row) {
                let buttons = '',
                    notificationButton = '<button type="button" title="Notifications" class="btn btn-purple btn-edit-notification-settings mr-1"><span class="fal fa-bell"></span></button>';
                if (this.options.enablePermissions) {
                    buttons += '<button type="button" title="Permissions" class="btn btn-dark btn-edit-user-perms mr-1"><span class="fal fa-key"></span></button>';
                    buttons += (row.get('userId') === PJQ.app.session.user.get('userId') || PJQ.app.session.hasPermission('users.canModifyNotifications')) ? notificationButton : ``
                } else {
                    buttons += notificationButton;
                }

                buttons += '<button type="button" title="Edit" class="btn btn-info btn-edit-user mr-1"><span class="fal fa-pencil"></span></button>'

                if (row.get('userId') !== PJQ.app.session.user.id) {
                    buttons += '<button type="button" title="Delete" class="btn btn-danger btn-delete-user"><span class="fal fa-trash"></span></button>';
                }

                return '<div class="text-align-center show-on-row-hover">' + buttons + '</div>';
            }, this)
        });

        this.renderUserSeats();
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".users-table"),
            data: this.collection.models,
            rowId: "cid",
            order: [1, 'asc'],
            language: {
                zeroRecords: "You don't have any users"
            },
            rowCallback: function (row, data) {
                if (data.userType) {
                    $(row).find('td:eq(7)').css('color', data.userType.get('color'));
                }
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editUser(row.data());
            }, this),
            onTableDraw: _.bind(function () {
                this.$(".users-table").find('th').each(function (index, column) {
                    if (index === 0) {
                        $(column).removeClass('sorting')
                    }
                });
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editUser(row.data());
                        }, this)
                    },
                    {
                        name: 'Notifications',
                        onClick: _.bind(function (row) {
                            this.notificationSettings(row.data());
                        }, this)
                    },
                    {
                        name: 'Permissions',
                        isShown: _.bind(function () {
                            return this.options.enablePermissions;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.editPermissions(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteUser(row);
                        }, this)
                    }
                ]
            },
            columns: columns
        });
    },
    renderUserSeats: function () {
        let $userSeats = this.$('.user-seats');
        if (!PJQ.app.session.get('onAccount') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            let subscription = PJQ.app.session.subscription;
            if (subscription.id === PJQ.constants.subscriptions.types.FREE || subscription.get('isFreeTrial')) {
                $userSeats.empty();
            } else {
                this.renderSubTemplate(false, this.options.subTemplates.userSeats, $userSeats, {
                    subscription: subscription,
                    users: this.collection
                }, _.bind(function () {
                    PJQ.app.session.listenSubscriptionChanged("accountSettings", _.bind(function () {
                        this.renderUserSeats();
                    }, this));
                }, this));
            }
        } else if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {
            PJQ.app.session.fetchUserLimits(_.bind(function (userLimits) {
                this.userLimits = userLimits;
                this.renderSubTemplate(false, this.options.subTemplates.userLimits, $userSeats, {
                    userLimits: userLimits,
                    users: this.collection,
                    showButtons: true
                });
            }, this))
        }
    },
    manageUserSeats: function () {
        new PJQ.views.settings.UserSeatsManagementModal();
    },
    manageUserLimits: function () {
        new PJQ.views.settings.UserLimitsManagementModal({
            model: this.userLimits,
            onSave: _.bind(function () {
                this.render();
            }, this)
        });
    },
    enablePermissions: function () {
        let enable = !this.options.enablePermissions;
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'permissions'
                },
                {
                    endpoint: 'enable'
                }
            ], [
                {
                    parameter: 'enable',
                    value: enable
                }
            ])
        }).put().done(_.bind(function () {
            if (enable) {
                PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS, true);
            } else {
                PJQ.app.session.preferences.deletePref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS);
            }
            this.render();
        }, this));
    },
    addClicked: function () {
        let fnNew = _.bind(function () {
            let newUser = new PJQ.models.users.User({
                companyName: PJQ.app.session.user.get('companyName'),
                contactName: "",
                username: "",
                email: "",
                phone: "",
                address1: PJQ.app.session.user.get('address1'),
                address2: PJQ.app.session.user.get('address2'),
                city: PJQ.app.session.user.get('city'),
                state: PJQ.app.session.user.get('state'),
                zip: PJQ.app.session.user.get('zip'),
                country: PJQ.app.session.user.get('country'),
                sortOrder: this.collection.length + 1,
                pmUser: true,
                itbUser: true,
                isActive: true,
                userTypeId: PJQ.app.session.userTypes.getDefault(true).get('userTypeId')
            });
            this.editUser(newUser);
        }, this);

        if (PJQ.app.session.user.isFetched) {
            fnNew();
        } else {
            PJQ.app.session.user.fetch({
                success: fnNew
            })
        }
    },
    notificationSettingsClicked: function (e) {
        let target = $(e.currentTarget),
            user = this.dataTable.getRow(target.closest('tr')).data();
        this.notificationSettings(user);
    },
    notificationSettings: function (user) {
        new PJQ.views.notificationSettings.NotificationSettingsEditorModal({
            model: user
        });
    },
    editPermissionsClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            user = row.data();

        this.editPermissions(user);
    },
    editPermissions: function (user) {
        new PJQ.views.permissions.PermissionsEditorModal({
            model: user
        });
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            user = row.data();

        this.editUser(user);
    },
    editUser: function (user) {
        let isNew = user.isNew();
        // force the modal to re-fetch
        user.isFetched = false;
        new PJQ.views.contacts.BaseEditContactModal({
            model: user,
            onSave: _.bind(function (user) {
                if (isNew) {
                    user.set('createdDate', new Date());
                    this.collection.add(user);
                    this.dataTable.addRow(user);
                }
                this.renderUserSeats();
                this.dataTable.refresh();
            }, this),
            onClose: _.bind(function (user) {
                if (user.hasChanged()) {
                    user.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                }
            }, this),
            onDelete: _.bind(function (user) {
                if (!user.isNew()) {
                    let row = this.dataTable.getRow(user.cid);
                    this.collection.remove(user);
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                    this.renderUserSeats();
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteUser(row);
    },
    deleteUser: function (row) {
        let user = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this user?",
            onDelete: _.bind(function () {
                this.collection.remove(user);
                user.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.settings.UserSeatsManagementModal = PJQ.views.payment.PaySimplePaymentModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'modal-user-seats-management'),
        minWidth: 500,
        onSave: null,
        onError: null,
        isVerticalCenter: true,
        isShowCloseButton: true,
        selectedSubscriptionId: null
    },
    defaultEvents: {
        'click .btn-add-seat': 'userSeatAdded',
        'click .btn-remove-seat': 'userSeatRemoved',
        'keyup .input-user-seats': 'userSeatsInputChanged',
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.userSeats = PJQ.app.session.subscription.get('userSeats');
        PJQ.app.session.subscription.getCostsPerUser(_.bind(function (costs) {
            this.changeCosts = costs;
            PJQ.app.session.fetchUsers(_.bind(function (users) {
                this.activeUsers = _.size(users.where({isActive: true}));
                this.render();
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            subscription: PJQ.app.session.subscription,
            userSeats: this.userSeats,
            activeUsers: this.activeUsers
        };
    },
    afterRender: function () {
        if (this.activeUsers == null) {
            new PJQ.Loader(this.$('.modal-content'));
            return;
        }
        this.$('.input-user-seats').focus().select();
    },
    userSeatAdded: function () {
        this.userSeats += 1;
        this.userSeatsChanged();
    },
    userSeatRemoved: function () {
        this.userSeats -= 1;
        this.userSeatsChanged();
    },
    userSeatsInputChanged: function () {
        this.userSeats = parseInt(this.$('.input-user-seats').val());
        this.userSeatsChanged();
    },
    userSeatsChanged: function () {
        this.$('.input-user-seats').val(this.userSeats);
        this.$('.btn-remove-seat').prop('disabled', this.userSeats === 0);

        let $err = this.$('.error-container'),
            $btnSave = this.$('.btn-save');
        if (this.userSeats < this.activeUsers) {
            // cant have less seats than active users
            $err.html("You can't select less seats than you have active users");
            $btnSave.prop('disabled', true);
        } else {
            let $payment = this.$('.payment-outer');
            if (this.userSeats > PJQ.app.session.subscription.get('userSeats')) {
                this.renderTotal();
                $payment.removeClass('hidden');
            } else {
                $payment.addClass('hidden');
            }

            $err.empty();
            $btnSave.prop('disabled', false);
        }
    },
    renderTotal: function () {
        let subscription = PJQ.app.session.subscription,
            cost;
        switch (subscription.id) {
            case PJQ.constants.subscriptions.types.BASIC:
                cost = this.changeCosts.basic;
                break;
            case PJQ.constants.subscriptions.types.PRO:
                cost = this.changeCosts.pro;
                break;
            case PJQ.constants.subscriptions.types.ENTERPRISE:
                cost = this.changeCosts.enterprise;
                break;
            default:
                cost = 0;
                break;
        }

        let $pOuter = this.$('.payment-outer'),
            newUserSeats = this.userSeats - subscription.get('userSeats');
        if (newUserSeats > 0) {
            this.$('.payment-total').html(PJQ.helpers.formatHelpers.formatCurrency(cost * newUserSeats, 2, true));
            this.$('.new-seats-count').html(newUserSeats);
            $pOuter.removeClass('hidden');
        } else {
            $pOuter.addClass('hidden');
        }
    },
    save: function () {
        if (this.userSeats !== PJQ.app.session.subscription.get('userSeats')) {
            let loader = new PJQ.Loader(this.$('.modal-content')),
                err = function () {
                    loader.remove();
                    PJQ.notifications.notify.errorNotify({
                        message: 'Encountered an error upgrading your subscription.  Please contact customer service.'
                    });
                };
            PJQ.app.session.changeUserSeats(this.userSeats, _.bind(function (data) {
                if (data == null || data.subscription == null) {
                    err();
                } else {
                    PJQ.notifications.notify.successNotify({
                        message: 'Users seats successfully updated'
                    });
                    this.removeModal();
                }
            }, this), _.bind(function () {
                err();
            }, this));
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.settings.UserLimitsManagementModal = PJQ.views.payment.PaySimplePaymentModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'modal-user-limits-management'),
        subTemplates: {
            userLimits: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'user-management-user-limits-header')
        },
        minWidth: 500,
        onSave: null,
        onError: null,
        isVerticalCenter: true,
        isShowCloseButton: true
    },
    defaultEvents: {
        'click .btn-add-itb-seat': 'itbUserSeatAdded',
        'click .btn-add-pm-seat': 'pmUserSeatAdded',
        'click .btn-remove-pm-seat': 'itbUserSeatRemoved',
        'click .btn-remove-itb-seat': 'pmUserSeatRemoved',
        'keyup .input-itb-user-seats': 'itbUserSeatsInputChanged',
        'keyup .input-pm-user-seats': 'pmUserSeatsInputChanged',
        'click .btn-cancel': 'cancel',
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        let fnFetchUsers = _.bind(function () {
            PJQ.app.session.fetchUsers(_.bind(function (users) {
                this.users = users;
                this.isFetched = true;
                this.render();
            }, this))
        }, this);

        if (this.model == null) {
            PJQ.app.session.fetchUserLimits(_.bind(function (userLimits) {
                fnFetchUsers();
            }, this))
        } else {
            fnFetchUsers();
        }
    },
    renderData: function () {
        return {
            model: this.model,
            itbUsers: this.itbUsers,
            pmUsers: this.pmUsers
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            new PJQ.Loader(this.$('.modal-content'));
            return;
        }
        this.$('.input-itb-user-seats').focus().select();

        this.renderHeader();
    },
    renderHeader: function(){
        this.renderSubTemplate(false, this.options.subTemplates.userLimits, this.$('.limits-header'), {
            userLimits: this.model,
            users: this.users
        });
    },
    pmUserSeatAdded: function () {
        this.model.set('pmUserLimit', this.model.get('pmUserLimit') + 1);
        this.userSeatsChanged();
    },
    pmUserSeatRemoved: function () {
        let seats = this.model.get('pmUserLimit');
        this.model.set('pmUserLimit', seats > 0 ? seats - 1 : 0);
        this.userSeatsChanged();
    },
    pmUserSeatsInputChanged: function () {
        let seats = parseInt(this.$('.input-pm-user-seats').val());
        if(isNaN(seats) || seats < 0){
            seats = 0;
        }
        this.model.set('pmUserLimit', seats);
        this.userSeatsChanged();
    },
    itbUserSeatAdded: function () {
        this.model.set('itbUserLimit', this.model.get('itbUserLimit') + 1);
        this.userSeatsChanged();
    },
    itbUserSeatRemoved: function () {
        let seats = this.model.get('itbUserLimit');
        this.model.set('itbUserLimit', seats > 0 ? seats - 1 : 0);
        this.userSeatsChanged();
    },
    itbUserSeatsInputChanged: function () {
        let seats = parseInt(this.$('.input-itb-user-seats').val());
        if(isNaN(seats) || seats < 0){
            seats = 0;
        }
        this.model.set('itbUserLimit', seats);
        this.userSeatsChanged();
    },
    userSeatsChanged: function () {
        this.renderHeader();
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    },
    save: function () {
        let loader = new PJQ.Loader(this.$('.modal-content')),
            err = function () {
                loader.remove();
                PJQ.notifications.notify.errorNotify({
                    message: 'Encountered an error update user seats'
                });
            };
        this.model.save(null, {
            success: _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'User seats updated'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave();
                }

                this.removeModal();
            }, this),
            error: _.bind(err, this)
        })
    }
});
